import React, { useEffect } from "react";
import TablaPermisos from "./TablaPermisos";
import { dbx } from "../../../utils/urlBack_End";
import { Skeleton } from "@material-ui/core";
import {
  comingSoonStyles,
  ComingSoonWrapper,
} from "src/components/coming-soon-screen/coming-soon-wrapper";
import { empleadosApi } from "src/services/empleadosApi";

export default function Permisos(props) {
  const {
    valueLaboral,
    empleado,
    setShowMessagePermiso,
    setColor,
    setMessage,
    vista,
  } = props;

  const { data, isLoading } = empleadosApi.useGetPermisosEmpleadoQuery(
    empleado.rut,
  );
  const permisos = data?.permisos ?? [];
  const permisosSolicitadas = data?.permisosSolicitadas ?? 0;

  useEffect(() => {
    if (empleado.rut !== undefined) {
      dbx
        .filesListFolder({ path: `/Empleados/${empleado.rut}/Permisos` })
        .then(() => {})
        .catch(() => {
          dbx
            .filesCreateFolderV2({
              path: `/Empleados/${empleado.rut}/Permisos`,
            })
            .then((response) => {})
            .catch((error) => {});
        })
        .finally(() => {});
    }
  }, [empleado.rut]);

  return (
    <>
      {valueLaboral === 3 && (
        <ComingSoonWrapper style={comingSoonStyles.CARD}>
          {!isLoading ? (
            <TablaPermisos
              permisos={permisos}
              permisosSolicitadas={permisosSolicitadas}
              empleado={empleado}
              setShowMessagePermiso={setShowMessagePermiso}
              setColor={setColor}
              setMessage={setMessage}
              vista={vista}
            />
          ) : (
            <Skeleton variant="rectangular" width="100%" height="426px" />
          )}
        </ComingSoonWrapper>
      )}
    </>
  );
}
